var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#cfccec",
    cx: 63.5,
    cy: 63.5,
    r: 63.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M103.36,51.25c-.36-1.09-1.24-1.86-2.36-2.06l-23.49-4.26-11.32-21.04c-.54-1-1.55-1.6-2.7-1.6-1.14,0-2.15.6-2.69,1.6l-11.32,21.04-23.41,4.25c-1.14.16-2.04.91-2.43,2.01-.39,1.11-.14,2.27.67,3.11l16.51,17.27-3.21,23.64c-.17,1.12.29,2.2,1.21,2.88.55.4,1.18.61,1.82.61.45,0,.9-.1,1.32-.31l21.52-10.37,21.52,10.37c1.02.49,2.19.38,3.12-.29.93-.67,1.39-1.75,1.24-2.87l-3.21-23.67,16.51-17.27c.78-.82,1.04-1.96.69-3.04ZM81.7,67.27c-1.35,1.42-1.93,3.2-1.67,5.14l2.43,17.89-16.26-7.84c-1.77-.85-3.64-.85-5.4,0l-16.26,7.84,2.42-17.88c.27-1.95-.31-3.72-1.67-5.14l-12.47-13.04,17.75-3.21c1.93-.35,3.44-1.45,4.36-3.18l8.55-15.9,8.55,15.9c.93,1.73,2.45,2.83,4.37,3.18l17.74,3.21-12.47,13.04h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5255e2f950eebcdc52acf1d728307318.svg";
export { ForwardRef as ReactComponent };